module.exports = {"421121100":"团风镇","421121101":"淋山河镇","421121102":"方高坪镇","421121103":"回龙山镇","421121104":"马曹庙镇","421121105":"上巴河镇","421121106":"总路咀镇","421121107":"但店镇","421121200":"贾庙乡","421121201":"杜皮乡","421121400":"黄湖农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421121.json
// module id = 1897
// module chunks = 0